module.exports = __webpack_public_path__ + "img/paraview-dark.f31ffd6b.svg";